import { render } from "./Route.vue?vue&type=template&id=0570cf88&scoped=true&lang=pug"
import script from "./Route.vue?vue&type=script&lang=ts"
export * from "./Route.vue?vue&type=script&lang=ts"

import "./Route.vue?vue&type=style&index=0&id=0570cf88&lang=scss&scoped=true"
import "./Route.vue?vue&type=style&index=1&id=0570cf88&lang=scss"
script.render = render
script.__scopeId = "data-v-0570cf88"

export default script